<template>
    <div v-if="isUserKCE">
        <div class="kce-container">
            <div class="kce-media__wrapper">
                <div class="kce-media__title">The basics</div>
                <div class="kce-video">
                    <youtube video-id="gj01264lwx0"></youtube>
                </div>
            </div>
        </div>
        <div class="kce-container">
            <div class="kce-media__wrapper">
                <div class="kce-media__title">Filling out a KENO card</div>
                <div class="kce-video">
                    <youtube video-id="hfaefb6Cez8"></youtube>
                </div>
            </div>
        </div>
        <div class="kce-container">
            <div class="kce-media__wrapper">
                <div class="kce-media__title">Advanced KENO tips</div>
                <div class="kce-video">
                    <youtube video-id="KTcjV6Ii5lg"></youtube>
                </div>
            </div>
        </div>
        <div class="kce-container">
            <div class="kce-media__wrapper">
                <div class="kce-media__title">Using the KENO self-service terminal</div>
                <div class="kce-video">
                    <youtube video-id="lFSNjhKrQDM"></youtube>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data: function () {
        return {
            copyDate: new Date().getFullYear(),
            isUserKCE: false
        }
    },
    mounted(){
        this.checkForRole();
    },
    methods: {
        checkForRole() {
            // alert('Checking for Role');
            let apiToken = $cookies.get('apiToken');
            let usersRoles = apiToken.user.listOfRoles;
            console.log("roles are:", usersRoles)
            if (usersRoles.includes('KenoCertifiedExpert')) {
                this.isUserKCE = true;
            }
        },
    }
}
</script>